import { getAllFeatureFlags, getFeatureFlag } from '../services/unleash-proxy.service'

/* eslint-disable no-shadow */
const state = () => ({
  features: {},
})

const getters = {
  getFeaturesState: (state) => state.features,
}

const mutations = {
  setFeatureFlags(state, featureFlags) {
    if (Array.isArray(featureFlags?.toggles)) {
      const newFlagState = {}

      featureFlags.toggles.forEach((flag) => {
        newFlagState[flag.name] = flag
      })

      state.features = newFlagState
    }
  },
  clearFeatureFlags(state) {
    state.features = {}
  },
}

const actions = {
  async fetchAllFeatureFlagState({ commit, rootState }) {
    const featureFlags = await getAllFeatureFlags(rootState?.account?.info?.email)
    commit('setFeatureFlags', featureFlags)
  },
  async fetchFeatureFlagState({ commit, rootState }, flagName) {
    const featureFlags = await getFeatureFlag(rootState?.account?.info?.email, flagName)
    commit('setFeatureFlags', featureFlags)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
